export interface AlainQRConfig {
  /** èæ¯ï¼é»è®¤ï¼`white` */
  background?: string;
  /** èæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ï¼é»è®¤ï¼`1` */
  backgroundAlpha?: number;
  /** åæ¯ï¼é»è®¤ï¼`black` */
  foreground?: string;
  /** åæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ï¼é»è®¤ï¼`1` */
  foregroundAlpha?: number;
  /** è¯¯å·®æ ¡æ­£çº§å«ï¼é»è®¤ï¼`L` */
  level?: 'L' | 'M' | 'Q' | 'H';
  /** äºç»´ç è¾åºå¾çMIMEç±»åï¼é»è®¤ï¼`image/png` */
  mime?: string;
  /** åè¾¹è·ï¼åä½ï¼pxï¼ï¼é»è®¤ï¼`10` */
  padding?: number;
  /** å¤§å°ï¼åä½ï¼pxï¼ï¼é»è®¤ï¼`220` */
  size?: number;
}
